import React, { useState } from 'react';

import { StyledInputWithButton } from './InputWithButton.styles';

import { InputWithButtonProps } from './InputWithButton.types';

import { Button } from '../../';

const InputWithButton = ({
  inputValue,
  onChangeInputValue,
  onSubmitInput,
  customButton = null,
  buttonContent,
  isDisabledButton = false,
  placeholder,
  componentClassname = 'input-with-button',
  customClassnames = '',
  customStyle = '',
  inputProps,
}: InputWithButtonProps) => {
  const [isInputMouseFocus, setIsInputMouseFocus] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeInputValue(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onSubmitInput();
  };

  return (
    <StyledInputWithButton
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      <input
        className={`${componentClassname}__input ${
          // Removing the blue accessibility outline on the input for cleaner style,
          // except when users are focusing it with a keyboard.
          isInputMouseFocus ? `${componentClassname}__input--no-outline` : ''
        }`}
        value={inputValue}
        placeholder={placeholder}
        onChange={handleChange}
        onMouseDown={() => setIsInputMouseFocus(true)}
        onBlur={() => setIsInputMouseFocus(false)}
        {...inputProps}
      />
      {customButton ? (
        customButton({
          type: 'submit',
          isDisabled: inputValue.trim() === '' || isDisabledButton,
          componentClassname: `${componentClassname}__button`,
          children: buttonContent,
          onClick: handleSubmit,
        })
      ) : (
        <Button
          buttonType="submit"
          isDisabled={inputValue.trim() === '' || isDisabledButton}
          componentClassname={`${componentClassname}__button`}
          handleClick={handleSubmit}
        >
          {buttonContent}
        </Button>
      )}
    </StyledInputWithButton>
  );
};
InputWithButton.displayName = 'InputWithButton';

export default InputWithButton;
